import PicklistMetadata from "../PicklistMetadata";

// What KIND of thing a catalog item is: Table, View, SQL Table, File, Other. Static, over the seeded
// 'Catalog Item Type' list of values -- which kinds exist is technology-dependent, so it is data
// rather than an enum in code.
class CatalogItemTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "CatalogItemType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Catalog Item Type";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default CatalogItemTypePicklistMetadata;
